import serviceDev from './service.dev';
import serviceProduction from './service.prod';
import serviceStaging from './service.staging';
import serviceKarma from "./service.karma";
import runtimeConfig from '../runtime';

let config = serviceDev;


if (runtimeConfig.REACT_APP_ENV === 'dev')
{
    config = serviceDev;
} else if (runtimeConfig.REACT_APP_ENV === 'staging')
{
    config = serviceStaging;
} else if (runtimeConfig.REACT_APP_ENV === 'karma')
{
    config = serviceKarma;
} else
{
    config = serviceProduction;
}

export default config;
